import { render, staticRenderFns } from "./AppHeaderCart.vue?vue&type=template&id=4c368a66"
import script from "./AppHeaderCart.vue?vue&type=script&lang=ts"
export * from "./AppHeaderCart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports